import { render, staticRenderFns } from "./WholesaleInquiryPages.vue?vue&type=template&id=ef693ae8&scoped=true&"
import script from "./WholesaleInquiryPages.vue?vue&type=script&lang=js&"
export * from "./WholesaleInquiryPages.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleInquiryPages.vue?vue&type=style&index=0&id=ef693ae8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef693ae8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
